import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';

export enum PhotoIdStep {
  Take = 'Take',
  Success = 'Success',
}

// No fail page exists; an unsuccessful attempt simply completes without retrying.
export const photoIdFlow: CheckinWorkflow<PhotoIdStep> = {
  id: FlowId.PhotoId,
  entry: PhotoIdStep.Take,
  steps: {
    [PhotoIdStep.Take]: {
      id: PhotoIdStep.Take,
      page: PageKey.PHOTO_ID,
      next: (variables) =>
        variables.isIdPictureSuccess ? { nextStep: PhotoIdStep.Success } : { complete: true },
    },
    [PhotoIdStep.Success]: {
      id: PhotoIdStep.Success,
      page: PageKey.PHOTO_ID_SUCCESS,
      next: () => ({ complete: true }),
      back: () => ({ nextStep: PhotoIdStep.Take }),
    },
  },
};
